// extracted by mini-css-extract-plugin
module.exports = {"root":"Info_root__2I6m-","requiredAsterisk":"Info_requiredAsterisk__p5vMe"};